import { Component, OnInit, Injector } from '@angular/core';
import { SecondPageEditBase } from 'vnpost-shared';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { CommissionsForSaleService } from '../../services/commissions-for-sale.service';

@Component({
  selector: 'app-create-commissions-for-sale',
  templateUrl: './create-commissions-for-sale.component.html',
  styleUrls: ['./create-commissions-for-sale.component.css']
})
export class CreateCommissionsForSaleComponent extends SecondPageEditBase
implements OnInit
{
listStatus: { label: string; value: number }[] = [
  { label: 'Đang áp dụng', value: 1 },
  { label: 'Ngừng áp dụng', value: 0 },
];

constructor(
  protected _service: CommissionsForSaleService,
  protected _injector: Injector,
) {
  super(_service, _injector);
  this.formGroup = new UntypedFormGroup({
    code: new UntypedFormControl('', [Validators.required]),
    name: new UntypedFormControl('', [Validators.required]),
    proportion: new UntypedFormControl(''),
    status: new UntypedFormControl(''),
    note: new UntypedFormControl(''),
  });
}

ngOnInit() {
}

onShowPopup() {
  this.validationSummary.resetErrorMessages();
  this.resetForm();
  this.onReset();

  this.itemDetail.id = 0;
  this.itemDetail.status = 1;
}

async save() {
  this.submitting = true;

  if (this.formGroup.invalid) {
    this.submitting = false;
    this.validationSummary.showValidationSummary();
    return;
  }
  
  this.onInsert();
}

onInsert() {
  this._service.create(this.itemDetail).then(
    (response) => {
      this.closePopupMethod(true);
      this._notifierService.showInsertDataSuccess();
      this.onAfterSave();
      this.submitting = false;
    },
    (error) => {
      this._notifierService.showInsertDataFailed();
      this.submitting = false;
    }
  );
}
}
